import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
  Text,
  Tooltip,
  useColorModeValue
} from "@chakra-ui/react";
import { useState } from "react";
import { RiArrowDownSLine, RiCheckLine, RiCloseLine } from "react-icons/ri";
import { useSearchParams } from "react-router-dom";
import { InputSearchWithoutDebounce } from "../../Form/Elements/InputSearch";
import { ButtonFilterStyle } from "./ButtonFilterStyle";

type Option = {
  name: string;
  value: string;
};

type Props = {
  label: string;
  name: string;
  options: Option[];
  onOpen?: () => void;
  isSearchable?: boolean;
  isLoading?: boolean;
};

export const DropdownFilter = ({
  label,
  name,
  options,
  onOpen,
  isSearchable = false,
  isLoading = false
}: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState<string>("");

  const activeBgColor = useColorModeValue("gray.200", "rgba(0,0,0, 0.4)");

  const valueSelected = searchParams.get(name);

  const clean = () => {
    searchParams.delete(name);
    setSearchParams(searchParams, { replace: true });
  };

  const handleSelected = (value: string) => {
    if (valueSelected != value) {
      searchParams.set(name, value);
      setSearchParams(searchParams, { replace: true });
    } else {
      clean();
    }
  };

  const optionSelected = options.find((x) => x.value == valueSelected);

  const optionsFiltered = options.filter((x) =>
    x.name.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <Menu autoSelect={false} closeOnSelect={true} onOpen={onOpen} gutter={-32}>
      <Flex align="center">
        <MenuButton
          as={ButtonFilterStyle}
          active={!!valueSelected}
          cursor="pointer"
          disabled={isLoading}
        >
          <Flex px="3" alignItems="center">
            <Text as="span" mr={1}>
              {optionSelected?.name || label}
            </Text>

            {isLoading ? (
              <Spinner size="xs" speed="0.8s" color="main.600" />
            ) : (
              <RiArrowDownSLine />
            )}
          </Flex>
        </MenuButton>
        {valueSelected && (
          <Tooltip label="Limpar" placement="top">
            <Button onClick={clean} variant="ghost" size="xs" p="0">
              <RiCloseLine />
            </Button>
          </Tooltip>
        )}
      </Flex>
      <MenuList>
        {isSearchable && (
          <Box mb="2" px={2}>
            <InputSearchWithoutDebounce
              size="sm"
              onChangeValue={setFilter}
              color="secondary"
            />
          </Box>
        )}
        {!isLoading && optionsFiltered.length == 0 && (
          <Box px={2} textAlign="center">
            <Text fontSize="sm">Nenhum resultado.</Text>
          </Box>
        )}
        {isLoading ? (
          <Box px={2} textAlign="center">
            <Text fontSize="sm">Carregando...</Text>
          </Box>
        ) : (
          <Box maxH={"48"} overflowY="auto">
            {optionsFiltered.map((x) => (
              <MenuItem
                key={x.value}
                value={x.value}
                bgColor={valueSelected == x.value ? activeBgColor : ""}
                icon={
                  valueSelected == x.value ? (
                    <RiCheckLine fontSize="1.1rem" />
                  ) : (
                    <Box w="18px" />
                  )
                }
                onClick={() => handleSelected(x.value)}
                fontSize="sm"
              >
                {x.name}
              </MenuItem>
            ))}
          </Box>
        )}
      </MenuList>
    </Menu>
  );
};
